export default __webpack_public_path__ + "static/media/rejected.06af042e.svg";